<template>
  <div class="vue-desktop-home-wrap">
    <div v-if="outageDataLoaded">
      <div class="header-container">
        <desktop-header :isDarkMode="isDarkMode" :drawerOpen="drawerOpen"/>
      </div>
      <map-info-modal
      v-if="mapInfoModalVisible"
      :hideModal="hideMapInfoModal"></map-info-modal>
      <map-home
      ref="map"
      :isDarkMode="isDarkMode"
      :mapView="mapView"
      :drawerOpen="drawerOpen"
      :townOutages="townOutages"
      :countyOutages="countyOutages"
      :utilityOutages="utilityOutages"
      :mapInfoIconClick="showMapInfoModal"></map-home>
      <navigation-drawer
      :user="user"
      :userIsAdmin="userIsAdmin"
      :username="username"
      :isDarkMode="isDarkMode"
      :selectedTab="mapView"
      :toggleDarkMode="onToggleDarkMode"
      :totalEvents="totalEventsQuickview"
      :totalCustomers="totalCustomersQuickview"
      :showLoginModal="showLoginModal"
      :townOutages="townOutages"
      :countyOutages="countyOutages"
      :utilityOutages="utilityOutages"
      :drawerOpen="onDrawerOpen"
      :drawerClosed="onDrawerClosed"
      :showHelpModal="showHelpModal"
      :showTownsLayer="showTownsLayer"
      :showCountiesLayer="showCountiesLayer"
      :showUtilitiesLayer="showUtilitiesLayer"
      :loginModalVisible="loginModalVisible"
      :userMenuVisible="userMenuVisible"
      :adminModalVisible="adminModalVisible"
      :onUserAvatarClicked="onUserAvatarClicked"
      :showDataModal="showDataModal"
      :userProfileModalVisible="userProfileModalVisible"
      :dataModalVisible="dataModalVisible"
      :uilityOutagesModalVisible="uilityOutagesModalVisible"
      :forceNewPasswordModalVisible="forceNewPasswordModalVisible"></navigation-drawer>
    </div>
    <help-modal
    v-if="helpModalVisible"
    :user="user"
    :userIsAdmin="userIsAdmin"
    :hideModal="hideHelpModal"/>
    <forgot-password-modal
    v-if="forgotPasswordModalVisible"
    :hideModal="hideForgotPasswordModal"
    :forgotPasswordSuccess="onForgotPasswordSuccess"/>
    <login-modal
    v-if="loginModalVisible"
    :hideModal="hideLoginModal"
    :loginSuccess="onLoginSuccess"
    :newPasswordRequired="onNewPasswordRequired"
    :forgotPasswordSuccess="forgotPasswordSuccess"
    :showForgotPasswordModal="showForgotPasswordModal"></login-modal>
    <user-menu
    v-if="user && userMenuVisible"
    :user="user"
    :userIsAdmin="userIsAdmin"
    :logOut="onLogOut"
    :hideUserMenu="hideUserMenu"
    :showAdminModal="onShowAdminModal"
    :showUserProfileModal="onShowUserProfileModal"
    :showUilityOutagesModal="onShowUilityOutagesModal"></user-menu>
    <user-profile-modal
    v-if="userProfileModalVisible"
    :user="user"
    :hideModal="onHideUserProfileModal"></user-profile-modal>
    <admin-modal
    v-if="adminModalVisible"
    :user="user"
    :hideModal="onHideAdminModal"></admin-modal>
    <force-new-password-modal
    v-if="forceNewPasswordModalVisible"
    :user="forceNewPasswordUser"
    :forceNewPasswordSuccess="onForceNewPasswordSuccess"></force-new-password-modal>
    <data-modal
    :user="user"
    v-if="dataModalVisible"
    :hideModal="hideDataModal"></data-modal>
    <uility-outages-modal
    v-if="uilityOutagesModalVisible"
    :refreshOutages="onRefreshOutages"
    :hideModal="onHideUilityOutagesModal"></uility-outages-modal>
  </div>
</template>

<script>
import DesktopHeader from "./DesktopHeader";
import RepeatedTask from "@/services/RepeatedTask";
import MapHome from "@/components/shared/map/MapHome";
import constants from "../../resources/constants.json";
import Authentication from "@/services/authentication";
import UserMenu from "@/components/shared/user/UserMenu";
import HomeMixin from "@/components/shared/mixins/HomeMixin";
import HelpModal from "@/components/shared/modals/HelpModal";
import LoginModal from "@/components/shared/modals/LoginModal";
import MapInfoModal from "@/components/shared/modals/MapInfoModal";
import DataModal from "@/components/shared/modals/data-modal/DataModal";
import ForgotPasswordModal from "@/components/shared/modals/ForgotPasswordModal";
import AdminModal from "@/components/shared/modals/admin-modal/AdminModal";
import ForceNewPasswordModal from "@/components/shared/modals/ForceNewPasswordModal";
import NavigationDrawer from "@/components/desktop/navigation-drawer/NavigationDrawer";
import UserProfileModal from "@/components/shared/modals/user-profile-modal/UserProfileModal";
import UilityOutagesModal from "@/components/shared/modals/utility-outages-modal/UilityOutagesModal";

export default {
  name: 'DesktopHome',
  mixins: [HomeMixin],
  created() {
    this.isDarkMode = this.getPreference(constants.DARK_MODE_KEY) === 'true' ? true : false;
    this.getData();
    this.getCurrentUser();
    this.repeatedTask = new RepeatedTask('DesktopHome', constants.OUTAGE_DATA_RELOAD_DELAY, this.getData);
  },
  beforeDestroy() {
    this.repeatedTask.cancel();
  },
  components: {
    MapHome,
    UserMenu,
    LoginModal,
    HelpModal,
    MapInfoModal,
    ForgotPasswordModal,
    DesktopHeader,
    AdminModal,
    NavigationDrawer,
    UserProfileModal,
    DataModal,
    UilityOutagesModal,
    ForceNewPasswordModal,
  },
  data() {
    return {
      user: undefined,
      userIsAdmin: undefined,
      username: undefined,
      isDarkMode: false,
      drawerOpen: true,
      outageDataLoaded: false,
      townOutages: undefined,
      countyOutages: undefined,
      utilityOutages: undefined,
      totalEventsQuickview: 0,
      totalCustomersQuickview: 0,
      // mapView: this.getPreference(constants.DATA_VIEW_KEY) || constants.DEFAULT_MAP_VIEW,
      mapView: constants.DEFAULT_MAP_VIEW,
      forceNewPasswordUser: undefined,
      forgotPasswordSuccess: undefined,
      helpModalVisible: false,
      userMenuVisible: false,
      loginModalVisible: false,
      adminModalVisible: undefined,
      dataModalVisible: false,
      mapInfoModalVisible: undefined,
      userProfileModalVisible: undefined,
      forceNewPasswordModalVisible: false,
      uilityOutagesModalVisible: undefined,
      forgotPasswordModalVisible: undefined,
    };
  },
  methods: {
    onToggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      this.setPreference(constants.DARK_MODE_KEY, this.isDarkMode);
    },
    onDrawerOpen() {
      this.drawerOpen = true;
    },
    onDrawerClosed() {
      this.drawerOpen = false;
    },
    showMapInfoModal() {
      this.mapInfoModalVisible = true;
    },
    hideMapInfoModal() {
      this.mapInfoModalVisible = undefined;
    },
    showForgotPasswordModal() {
      this.forgotPasswordModalVisible = true;
    },
    hideForgotPasswordModal() {
      this.forgotPasswordModalVisible = undefined;
    },
    showHelpModal() {
      this.helpModalVisible = true;
    },
    hideHelpModal() {
      this.helpModalVisible = false;
    },
    showDataModal() {
      this.dataModalVisible = true;
    },
    hideDataModal() {
      this.dataModalVisible = undefined;
    },
    showLoginModal() {
      this.loginModalVisible = true;
    },
    hideLoginModal() {
      this.loginModalVisible = undefined;
    },
    hideUserMenu() {
      this.userMenuVisible = undefined;
    },
    onForgotPasswordSuccess() {
      this.forgotPasswordSuccess = true;
      this.hideForgotPasswordModal();
      this.showLoginModal();
    },
    onUserAvatarClicked() {
      this.userMenuVisible = !this.userMenuVisible;
    },
    onShowUserProfileModal() {
      this.hideUserMenu();
      this.userProfileModalVisible = true;
    },
    onHideUserProfileModal() {
      this.userProfileModalVisible = undefined;
    },
    onShowAdminModal() {
      this.hideUserMenu();
      this.adminModalVisible = true;
    },
    onHideAdminModal() {
      this.adminModalVisible = undefined;
    },
    onShowUilityOutagesModal() {
      this.hideUserMenu();
      this.uilityOutagesModalVisible = true;
    },
    onHideUilityOutagesModal() {
      this.uilityOutagesModalVisible = undefined;
    },
    async onRefreshOutages() {
      await this.getData(true);
    },
    onLoginSuccess(user) {
      this.user = user;
      this.username = user.username;
      this.forgotPasswordSuccess = undefined;
      this.hideLoginModal();
      this.checkIfUserIsAdmin();
    },
    onNewPasswordRequired(user) {
      this.hideLoginModal();
      this.forceNewPasswordUser = user;
      this.forceNewPasswordModalVisible = true;
    },
    onForceNewPasswordSuccess() {
      this.getCurrentUser();
      this.forceNewPasswordModalVisible = undefined;
    },
    async onLogOut() {
      try {
        await Authentication.signOut();
        this.user = undefined;
        this.username = undefined;
        this.userMenuVisible = false;
        this.hideLoginModal();
      } catch (error) {
          console.log('onLogOut - catch: ', error);
      }
    }
  }
}
</script>
